import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase-config';

const DEBUG = process.env.REACT_APP_DEBUG;

export const logEventFirebase = (event: string, params = {}) => {
    if (DEBUG) {
        return;
    }
    if (analytics) {
        logEvent(analytics, event, params);
    }
};
